import React, { useContext, useEffect, useState } from "react";
import "moment-timezone";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import { OverlayTrigger, Tooltip, Placeholder } from "react-bootstrap";
import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import { Link } from "react-router-dom";
import { EngReportCont } from "./EngagementReport";
import {
  ADMIN_REP_ACCESS,
  ascendingHeader,
  headerOne,
  headerTwo,
  tableHeaderData,
} from "./engagement_cf";
import { currentUser } from "modules/utilities/utility";
import { get } from "lodash";
import { UNANSWER_ENG } from "config";

function EngagementReportTable({
  filterData,
  isLoading,
  error,
  setSortBy,
  activeTab,
  applyFilter,
  tab,
}) {
  const [scheduled, setSchedule] = useState(0);
  const [created, setCreated] = useState(0);
  const [updated, setUpdated] = useState(0);
  const [allFlag, setAllFlag] = useState(false);
  const { checkedFilter, setCheckedFilter } = useContext(EngReportCont);

  useEffect(() => {
    setCheckedFilter(filterData);
  }, [filterData]);

  function handleScheduleAt(sortQuery) {
    setSortBy(sortQuery);
  }

  const order = {
    0: 1,
    1: -1,
    "-1": 0,
  };

  const sortQuery = (field, type) => {
    switch (type) {
      case -1:
        return `-${field}`;
      case 0:
        return ``;
      case 1:
        return field;
    }
  };

  const handleChange = (event, itemId) => {
    if (event.target.checked) {
      setCheckedFilter((prevData) =>
        prevData?.map((item) =>
          item?._id === itemId ? { ...item, checked: true } : item
        )
      );
    } else {
      setCheckedFilter((prevData) =>
        prevData?.map((item) =>
          item._id === itemId ? { ...item, checked: false } : item
        )
      );
    }
  };

  const handleAllChange = (event) => {
    if (event.target.checked) {
      setCheckedFilter((prevData) =>
        prevData?.map((item) => ({ ...item, checked: true }))
      );
      setAllFlag(true);
    } else {
      setCheckedFilter((prevData) =>
        prevData?.map((item) => ({ ...item, checked: false }))
      );
      setAllFlag(false);
    }
  };

  return (
    <div className="scrollable-table-feed scrollable-container rounded-top">
      <table className="table table-responsive table-striped table-bordered table-hover">
        <thead style={{ background: "#EAF0FC" }} className="rounded-top">
          <tr>
            {ADMIN_REP_ACCESS.includes(currentUser) ? (
              <th
                style={{
                  position: "sticky",
                  left: "0rem",
                  top: "0",
                  zIndex: "4",
                  background: "rgb(234,240,252)",
                }}
                className="flex-1 align-top text-center table-head"
              >
                <input
                  type="checkbox"
                  checked={allFlag ? true : false}
                  onChange={handleAllChange}
                />
              </th>
            ) : null}
            <th
              style={{
                maxWidth: "12rem",
                minWidth: "12rem",
                position: "sticky",
                left: ADMIN_REP_ACCESS.includes(currentUser)
                  ? "2.8rem"
                  : "0rem",
                background: "#EAF0FC",
                top: "0",
                zIndex: "4",
              }}
              className="align-top text-center "
            >
              Agent Name
            </th>
            {tableHeaderData(headerOne)}
            {UNANSWER_ENG.includes(tab) && (
              <th
                style={{
                  minWidth: "12rem",
                  background: "#EAF0FC",
                  top: "0",
                  position: "sticky",
                }}
                className="align-top text-center"
              >
                Partially Answered
              </th>
            )}
            {activeTab === "slot_booking_total" && (
              <th
                style={{
                  minWidth: "12rem",
                  background: "#EAF0FC",
                  top: "0",
                  position: "sticky",
                }}
                className="align-top text-center"
              >
                Tag
              </th>
            )}
            <th
              style={{
                minWidth: "12rem",
                background: "#EAF0FC",
                top: "0",
                position: "sticky",
              }}
              className="align-top text-center"
            >
              Status
            </th>

            {ascendingHeader(
              "scheduleAt",
              handleScheduleAt,
              order,
              scheduled,
              setSchedule,
              sortQuery
            )}
            {tableHeaderData(headerTwo)}
            {activeTab === "week1" && (
              <th
                style={{
                  minWidth: "12rem",
                  background: "#EAF0FC",
                  top: "0",
                  zIndex: "4",
                  position: "sticky",
                }}
                className="align-top text-center"
              >
                Laggar
              </th>
            )}
            {ascendingHeader(
              "createdAt",
              handleScheduleAt,
              order,
              created,
              setCreated,
              sortQuery
            )}
            {ascendingHeader(
              "updatedAt",
              handleScheduleAt,
              order,
              updated,
              setUpdated,
              sortQuery
            )}
          </tr>
        </thead>
        <tbody>
          {isLoading
            ? Array.from({ length: 5 }).map((_, index) => (
                <tr key={index}>
                  {Array.from({ length: 13 }).map((_, index) => (
                    <td key={index}>
                      <Placeholder as="p" animation="glow">
                        <Placeholder xs={12} />
                      </Placeholder>
                    </td>
                  ))}
                </tr>
              ))
            : checkedFilter?.map((row) => {
                return (
                  <tr key={row?._id} className="p-4">
                    {ADMIN_REP_ACCESS.includes(currentUser) ? (
                      <td
                        style={{
                          minWidth: "1.5rem",
                          maxWidth: "1.5rem",
                          position: "sticky",
                          left: "0",
                          zIndex: "1",
                          backgroundColor: "#C7D2E1",
                        }}
                      >
                        <input
                          type="checkbox"
                          value={row?._id}
                          id={`flexCheckIndeterminate-${row?._id}`}
                          onClick={(event) => handleChange(event, row?._id)}
                          checked={row?.checked}
                        />
                      </td>
                    ) : null}
                    <td
                      style={{
                        width: "14rem",
                        position: "sticky",
                        left: ADMIN_REP_ACCESS.includes(currentUser)
                          ? "2.8rem"
                          : "0rem",
                        backgroundColor: "rgb(199,210,225)",
                      }}
                    >
                      {row?.rep?.first_name}
                    </td>
                    <td className="text-center">
                      {row?.tempRep ? row?.tempRep?.first_name : "N/A"}
                    </td>
                    <td className="text-center">
                      <span
                        className={`badge ${
                          row?.eg_status === "completed"
                            ? "bg-success"
                            : row?.eg_status === "yet-to-pickup"
                            ? "bg-secondary"
                            : "bg-danger"
                        }`}
                      >
                        {row?.eg_status === "completed"
                          ? "Completed"
                          : row?.eg_status === "yet-to-pickup"
                          ? "Yet to Pick Up"
                          : "In Progress"}
                      </span>
                    </td>
                    <td>
                      <a
                          href={`/lead-details/${row?.user?.case_id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                      >
                        <OverlayTrigger
                            overlay={
                              <Tooltip placement="left">
                                <div className="fs-1">Lead Details</div>
                              </Tooltip>
                            }
                        >
                          <span className="text-capitalize">
                            {row?.user?.first_name}
                          </span>
                        </OverlayTrigger>
                      </a>
                    </td>
                    <td>
                      <span className="text-capitalize">
                        {" "}{row?.user?.gender == 'M' ?  'Male': 'Female'}
                        </span>
                    </td>
                    {UNANSWER_ENG.includes(tab) && (
                      <td className="text-center">
                        <span className="badge bg-primary">
                        {(() => {
                          const lastAttempt = row?.activity?.attempts?.[row?.activity?.attempts?.length - 1];
                          let response = get(lastAttempt, "attempt_info.responses", null);
                          return   response?.dont_want_talk && "do_not_want_talk" ||
                          response?.script_unfullfill && "script_unfullfill" ||
                          response?.cx_wants_callBack && "cx_wants_callBack" ||
                          response?.did_not_pick_up && "did_not_pick_up" ||
                          "No";
                        })()}
                        </span>
                      </td>
                    )}

                    {activeTab === "slot_booking_total" && (
                      <td className="text-center">
                        {row?.request_type === "forced_slot"
                          ? "Forced Slot"
                          : row?.request_type === "lead_cold_slot"
                          ? "Lead Cold Call"
                          : row?.tag}
                      </td>
                    )}
                    <td className="text-center text-capitalize">
                      {row?.status}
                    </td>
                    <td className="text-center">{row?.reminder_date}</td>
                    <td className="text-center">{row?.call_activity?.start}</td>
                    <td className="text-center">{row?.call_activity?.end}</td>
                    <td className="text-center">
                      {row?.call_activity?.duration}
                    </td>
                    <OverlayTrigger
                      overlay={
                        <Tooltip
                          style={{ position: "fixed" }}
                          id="overlay-trigger-example"
                        >
                          <div className="fw-bold">{row?.notes}</div>
                        </Tooltip>
                      }
                    >
                      <td className="text-center ">
                        <div
                          className="text-center d-inline-block text-truncate"
                          style={{ width: "15rem", maxHeight: "2rem" }}
                        >
                          {row?.notes}
                        </div>
                      </td>
                    </OverlayTrigger>
                    {activeTab === "week1" && <td>{row.lagger}</td>}
                    <td>{row.createdAt}</td>
                    <td>{row.updatedAt}</td>
                  </tr>
                );
              })}
        </tbody>
      </table>
    </div>
  );
}

export default EngagementReportTable;
